<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton-table :rows="perPage" :columns="5" :table-props="{ bordered: true, striped: true }" small>
        </b-skeleton-table>
      </template>
      <component :is="component" :scenario="scenario" :flow=flow v-if="component" @OnSubmit="onSubmit"/>
    </b-skeleton-wrapper>
   
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    scenario: {
      type: Object
    },
    flow: {
      type: Object
    }
  },
  async beforeMount() {

  },
  data() {
    return {
      component: null,
      loading: false,
      perPage: 5,
      currentPage: 1,
    }
  },
  methods: {
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval)
      this.$_loadingTimeInterval = null
    },
    makeToast() {
      this.$bvToast.toast('정상적으로 등록 되었습니다.', {
        title: `200 OK`,
        variant: 'success',
        solid: true
      })
    },
    onSubmit(){
      this.makeToast();
      this.loading = true
      // console.log('============ ===== =========== ======== ========= ======== ============ ========== ========= ============== ========');
      this.loader()
      .then(() => {
          this.component = () => this.loader()
          this.$emit('OnSubmit');
      })
      .catch(() => {
          this.component = () => import('./form/Originate')
      })
      
    }
  },
  mounted() {
    this.loader()
      .then(() => {
          this.component = () => this.loader()
      })
      .catch(() => {
          this.component = () => import('./form/Originate')
      })
  },
  computed: {
    loader() {
      // console.log('call thos --->>>>>> ', this.flow.bizStep)
      this.loading = true
        return () => import(`./form/${this.flow.bizStep}`)
    },
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval()
        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loading = false;
            this.onComplate = true;
          }, 1000)
        }
      }
    },
  },
  filters: {
  }
}
</script>